import { render, staticRenderFns } from "./table-fligth.vue?vue&type=template&id=5441dc40&scoped=true&"
import script from "./table-fligth.vue?vue&type=script&lang=js&"
export * from "./table-fligth.vue?vue&type=script&lang=js&"
import style0 from "./table-fligth.vue?vue&type=style&index=0&id=5441dc40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5441dc40",
  null
  
)

export default component.exports